import { HTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '@sib/ui';

export const TicketSectionWrapper = ({
  children,
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div
      className={cn(
        'border-border flex w-full flex-col gap-5 rounded-md border-1 p-3.5 shadow-lg',
        props.className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
